import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import styled, { css } from "styled-components";

import breakpoints from "_constants/breakpoints";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
  background-color: #ffffff;
  width: ${({ theme: { mobile } }) => (mobile ? "100%" : "316px")};
  min-height: 270px;
  box-shadow: 0px 3px 25px rgba(168, 168, 168, 0.3);
  padding: 45px;
  margin: ${({ theme: { mobile } }) => (mobile ? "0 0 14px" : "0 24px 48px")};

  @media (max-width: ${breakpoints.mobileM}) {
    padding: 24px;
  }

  ${({ theme: { mobile } }) =>
    !mobile &&
    css`
      @media (max-width: 1350px) {
        flex-direction: row;
        gap: 24px;
        order: 1;
        width: 90%;
        margin-bottom: 24px;
        min-height: auto;
        padding: 24px;
      }

      @media (max-width: 700px) {
        flex-direction: column;
        align-items: center;
      }
    `}
`;
const Button = styled.button`
  font-family: "Montserrat";
  width: 100%;
  height: 42px;
  background: #f37217;
  border: none;
  border-radius: 4px;
  color: #ffffff;
  font-size: 16px;
  font-weight: 700;
  &:not(:last-child) {
    margin-bottom: 10px;
  }

  @media (max-width: 700px) {
    font-size: 14px;
  }

  @media (max-width: ${breakpoints.mobileM}) {
    font-size: 12px;
  }

  ${({ theme: { mobile } }) =>
    !mobile &&
    css`
      @media (max-width: 1350px) {
        width: 33.3%;
        height: 64px;
        margin-bottom: 0 !important;
      }

      @media (max-width: 700px) {
        width: 100%;
      }
    `}
`;

const mockFn = () => {};

export default function UserProfile({ scrollToContent = mockFn }) {
  const navigate = useNavigate();

  const clickHandler = (to) => {
    navigate(to, { replace: true });
    scrollToContent();
  };

  return (
    <Container>
      <Button onClick={() => clickHandler("/user")}>Personal Information</Button>
      <Button onClick={() => clickHandler("/billing-info")}>Billing Information</Button>
      <Button onClick={() => clickHandler("/subscriptions")}>Subscriptions</Button>
      <Button onClick={() => clickHandler("/")}>Orders</Button>
    </Container>
  );
}

UserProfile.propTypes = {
  scrollToContent: PropTypes.func,
};
